import type {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import type {GetResponse, ParamsOptions} from "@/src/modules/core/types";
import {axios, getParams} from "@/src/modules/core/lib";

import type {
  PanicAlert,
  PanicAlertCreateEnvelope,
  PanicAlertListResponse,
  PanicAlertStats,
  PanicAlertUpdatePayload,
  PanicButtonConfig,
  PanicCancelResponse,
  PanicConfirmPayload,
  PanicConfirmResponse,
  PanicIntentPayload,
  PanicIntentResponse,
} from "../types";

class PanicAlertsApi extends CoreApi {
  getConfig(propertyId?: number): Promise<AxiosResponse<GetResponse<PanicButtonConfig>>> {
    return axios({
      url: "panic-button/config",
      method: "get",
      params: propertyId ? {property_id: propertyId} : undefined,
    });
  }

  intent(data: PanicIntentPayload): Promise<AxiosResponse<GetResponse<PanicIntentResponse>>> {
    return this.post("panic-alert/intent", data);
  }

  confirm(data: PanicConfirmPayload): Promise<AxiosResponse<GetResponse<PanicConfirmResponse>>> {
    return this.post("panic-alert/confirm", data);
  }

  cancel(intentToken: string): Promise<AxiosResponse<GetResponse<PanicCancelResponse>>> {
    return axios({
      url: "panic-alert/intent",
      method: "delete",
      data: {intent_token: intentToken},
    });
  }

  list(options?: ParamsOptions): Promise<AxiosResponse<PanicAlertListResponse>> {
    return axios({
      url: "panic-alerts",
      method: "get",
      params: getParams(options),
    });
  }

  show(id: number): Promise<AxiosResponse<GetResponse<PanicAlert>>> {
    return this.getById("panic-alert", id);
  }

  patchAlert(
    id: number,
    data: PanicAlertUpdatePayload,
  ): Promise<AxiosResponse<GetResponse<PanicAlert>>> {
    return super.update("panic-alert", id, data);
  }

  getCreateOptions(): Promise<AxiosResponse<GetResponse<PanicAlertCreateEnvelope>>> {
    return this.get("panic-alert/create");
  }

  getOfficerStatus(propertyId: number): Promise<AxiosResponse<unknown>> {
    return this.get(`panic-alert/property/${propertyId}/officer-status`);
  }

  getStatistics(): Promise<AxiosResponse<GetResponse<PanicAlertStats>>> {
    return this.get("panic-alert/statistics");
  }
}

export const panicAlertsApi = new PanicAlertsApi();
